module.exports = __webpack_public_path__ + "img/xiaoshuai.28b6a981.jpg";